import PropTypes from "prop-types";
// msal
import {
  PublicClientApplication,
  InteractionType,
  EventType,
} from "@azure/msal-browser";
import {
  MsalProvider,
  MsalAuthenticationTemplate,
  UnauthenticatedTemplate,
} from "@azure/msal-react";
// provider
import MsalAppAuthenticationProvider from "./MsalAppAuthenticationProvider";
import { msalAuthConfiguration } from "./config";

// Init msal client
const msalClient = new PublicClientApplication({
  auth: {
    ...msalAuthConfiguration,
  },
  cache: {
    cacheLocation: "localStorage",
  },
});

await msalClient.initialize();

if (!msalClient.getActiveAccount() && msalClient.getAllAccounts().length > 0) {
  // Account selection logic is app dependent. Adjust as needed for different use cases.
  msalClient.setActiveAccount(msalClient.getAllAccounts()[0]);
}

msalClient.enableAccountStorageEvents();

// Set Default active account after login succes
msalClient.addEventCallback((msg) => {
  console.log(msg);
  if (msg.eventType === EventType.LOGIN_SUCCESS) {
    msalClient.setActiveAccount(msg.payload);
  }
});

// This Provider use for manage Active Account only.
// See MsalAppAuthenticationProvider.jsx to feature detail about get accessToken of API

MsalAuthenticationProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default function MsalAuthenticationProvider({ children }) {
  return (
    <MsalProvider instance={msalClient}>
      <MsalAuthenticationTemplate interactionType={InteractionType.Redirect}>
        <MsalAppAuthenticationProvider>
          {children}
        </MsalAppAuthenticationProvider>
      </MsalAuthenticationTemplate>
      <UnauthenticatedTemplate>
        <p>Initialize signing in</p>
        <p>Please sign in to continue</p>
      </UnauthenticatedTemplate>
    </MsalProvider>
  );
}
